const meta = {
  datadog: 'Datadog',
  prometheus: 'Prometheus',
  signalfx: 'SignalFx',
  wavefront: 'Wavefront',
};

export default meta;
